import React, { useState } from 'react';
import { Button, Card, Checkbox, Form, Input, message, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { api } from '../../http/API';

const { Title, Paragraph, Link, Text } = Typography;

const OFFER_URL = 'https://agropogoda.com/static/files/public_offer.pdf';
const PRIVACY_URL = 'https://agropogoda.com/static/files/privacy.pdf';

const RegisterPage: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values: any) => {
        if (!values.accept_platform_offer || !values.accept_pd_consent) {
            message.error('Необходимо принять оба документа');
            return;
        }
        if (values.password !== values.confirm) {
            message.error('Пароли не совпадают');
            return;
        }
        setLoading(true);
        try {
            await api.Register({
                email: values.email.trim().toLowerCase(),
                password: values.password,
                accept_platform_offer: true,
                accept_pd_consent: true,
            });
            message.success('Регистрация создана. Проверьте почту — мы отправили код.');
            navigate('/register/verify', { state: { email: values.email.trim().toLowerCase() } });
        } catch (error: any) {
            const msg = error?.response?.data?.message || 'Не удалось зарегистрироваться';
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5', padding: 24 }}>
            <Card style={{ width: 460, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <Title level={3} style={{ textAlign: 'center' }}>Регистрация</Title>
                <Paragraph type="secondary" style={{ textAlign: 'center' }}>
                    Создайте аккаунт на платформе Агропогода
                </Paragraph>

                <Form layout="vertical" onFinish={onFinish} autoComplete="off">
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Введите email' },
                            { type: 'email', message: 'Некорректный email' },
                        ]}
                    >
                        <Input prefix={<MailOutlined />} placeholder="you@example.com" />
                    </Form.Item>
                    <Form.Item
                        label="Пароль"
                        name="password"
                        rules={[
                            { required: true, message: 'Введите пароль' },
                            { min: 8, message: 'Минимум 8 символов' },
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Пароль" />
                    </Form.Item>
                    <Form.Item
                        label="Повторите пароль"
                        name="confirm"
                        dependencies={['password']}
                        rules={[
                            { required: true, message: 'Повторите пароль' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Пароли не совпадают'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Повторите пароль" />
                    </Form.Item>

                    <Form.Item
                        name="accept_platform_offer"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, v) =>
                                    v ? Promise.resolve() : Promise.reject(new Error('Примите оферту платформы')),
                            },
                        ]}
                    >
                        <Checkbox>
                            Принимаю{' '}
                            <a href={OFFER_URL} target="_blank" rel="noreferrer">
                                Публичную оферту платформы
                            </a>
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="accept_pd_consent"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, v) =>
                                    v ? Promise.resolve() : Promise.reject(new Error('Дайте согласие на обработку ПДн')),
                            },
                        ]}
                    >
                        <Checkbox>
                            Даю{' '}
                            <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
                                согласие на обработку персональных данных
                            </a>
                        </Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Зарегистрироваться
                        </Button>
                    </Form.Item>

                    <div style={{ textAlign: 'center' }}>
                        Уже есть аккаунт?{' '}
                        <Link onClick={() => navigate('/login')}>Войти</Link>
                    </div>
                </Form>
            </Card>
        </div>
    );
};

export default RegisterPage;
